
  import { createRoot } from "react-dom/client";
  import App from "./App.tsx";
  import { installEncodedLocalStorage } from "./utils/localStorageCodec";
  import { shouldBlockAutomationInCurrentRuntime } from "./helpers/automationGuard";
  import "./index.css";

  installEncodedLocalStorage();

  const root = createRoot(document.getElementById("root")!);

  if (shouldBlockAutomationInCurrentRuntime()) {
    root.render(
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          padding: "24px",
          background: "#f8fafc",
          color: "#0f172a",
          fontFamily: "system-ui, sans-serif",
        }}
      >
        <div style={{ maxWidth: "520px", textAlign: "center" }}>
          <h1 style={{ marginBottom: "8px", fontSize: "1.5rem", fontWeight: 700 }}>
            Access blocked
          </h1>
          <p style={{ margin: 0, lineHeight: 1.6 }}>
            Your browsing environment does not meet our security requirements. If you believe this is an error, please try again using a regular browser session.
          </p>
        </div>
      </div>
    );
  } else {
    root.render(<App />);
  }
  
